import { api } from '@/api/core';

export interface MatterIngestRequest {
  globalAdminAsUser?: string;
  matterId: string;
}

const matterIngestApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postMatterIngest: builder.mutation<unknown, MatterIngestRequest>({
      query: (body) => ({
        url: '/matter/ingest',
        method: 'POST',
        body,
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { usePostMatterIngestMutation } = matterIngestApi;
